import sensors from './map/nodes'
import slider from './map/slider'
import pollutionAreas from './map/pollutionAreas'
import app from './map/app'
import heatmaps from './map/heatmaps'
import analytics from './map/analytics'
import noise from './map/noise'
import nodeCharts from './stations/stationCharts'
import nodeDetails from './nodes/nodeDetails'
import user from './users/user'
import manageUsers from './users/manageUsers'
import organizations from './organizations/organizations'
import stations from './stations/stations';
import devices from './devices/devices';
import WebSocket from './WebSocket';

import { combineReducers } from 'redux'

export default combineReducers({
    sensors,
    slider,
    pollutionAreas,
    app,
    heatmaps,
    analytics,
    noise,
    nodeCharts,
    nodeDetails,
    user,
    manageUsers,
    organizations,
    stations,
    devices,
    WebSocket
})



// WEBPACK FOOTER //
// ./src/reducers/index.js